import { useEffect } from 'react';

export const useKeyboardListener = (
    handler: (key: string, e: globalThis.KeyboardEvent) => void
) => {
    useEffect(() => {
        const keyDownHandler = (e: globalThis.KeyboardEvent) => {
            handler(e.key, e);
        };
        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    });
};
